import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { permissionColumns } from "./utils";
import formatError from "../../../../services/FormatError";
import { fetchAllPermissions } from "../../../../services/RolesServices";
import { useTranslation } from "react-i18next";

const PermissionModal = (props) => {
  const { t } = useTranslation();
  const [allPermission, setAllPermission] = useState([]);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    fetchAllPermissions()
      .then((res) => {
        const response = res?.data?.result;
        let assignedId = props?.formValues?.permission?.map((y) => y.id);

        const uniqueArray = response?.filter(
          (x) => !assignedId?.includes(x.id)
        );

        setAllPermission(uniqueArray);

        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: uniqueArray?.length,
        }));
      })
      .catch((error) => {
        formatError(error.message);
      });
  }, [props?.formValues]);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      if (props.formValues?.permission?.length === 0) {
        props.setFormValues((prevState) => ({
          ...prevState,
          permission: [...selectedRows],
        }));
      } else {
        const newPermissions = selectedRows.filter(
          (row) =>
            !props.formValues?.permission?.some(
              (existingPermission) => existingPermission?.id === row?.id
            )
        );

        props.setFormValues((prevState) => ({
          ...prevState,
          permission: [...prevState?.permission, ...newPermissions],
        }));
      }
      props.setPermissionTableData((prev) => [...prev, ...selectedRows]);
    },
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  return (
    <Modal
      className="modal fade "
      dialogClassName="modal-90w"
      size="xl"
      show={props.showAddModal}
      onHide={props.onHideModal}
    >
      <div className="" role="document">
        <div className="">
          <form>
            <div className="modal-header">
              <h4 className="modal-title fs-20">{t("add_permissions")}</h4>
              <button
                type="button"
                className="close btn"
                onClick={props.onHideModal}
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>

              <div className="mt-4">
                <Table
                  rowSelection={{
                    type: "checkbox",
                    ...rowSelection,
                  }}
                  columns={permissionColumns(tableParams, t)}
                  rowKey={(record) => record.id}
                  dataSource={allPermission}
                  pagination={tableParams}
                  onChange={handleTableChange}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  props.setShowAddPermission(false);
                }}
              >
                {t("add")}
              </button>
              <button
                type="reset"
                onClick={props.onHideModal}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i>
                &nbsp;{t("discard")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default PermissionModal;
